export const convertVitaminDToIU = (amountInMcg) => amountInMcg * 40;
export const convertVitaminDToMcg = (amountInUI) => amountInUI / 40;
//# sourceMappingURL=unitConversionUtils.js.map